<style>
#grid table {
      table-layout: fixed;
      width: 99.9% !important;
}

li.k-current-page {
      display: none !important;
}

.k-pager-sm .k-pager-numbers-wrap {
      margin-left: 0px !important;
      margin-right: 0px !important;
      width: 32.5px;
      height: 33.5px;
}

.k-pager-sm .k-pager-numbers-wrap .k-pager-numbers {
      display: flex !important;
}

#grid.extrato tbody tr {
      height: 15px;
}

#grid.extrato td {
      white-space: nowrap;
      padding: 5px;
}

li span.k-state-selected {
      border-color: rgba(33, 37, 41, 0.125);
      color: #007bff;
      background-color: #fff;
      border-radius: 0;
      padding: 0.375rem 0.375rem;
      border-width: 1px;
      border-style: solid;
      min-width: calc(1.5em + 0.75rem + 2px);
      height: calc(1.5em + 0.75rem + 2px);
      box-sizing: border-box;
      color: inherit;
      text-align: center;
      display: -ms-inline-flexbox;
      display: inline-flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      position: relative;
}

.k-grid-content {
      width: 100.1% !important;
}

@media print {
      td {
            white-space: break-spaces !important;
      }

      table {
            table-layout: auto !important;
            width: 100vw !important;
      }

      div#grid {
            table-layout: auto !important;
            width: 95vw !important;
      }

      .k-toolbar .navbar .btn {
            display: none !important;
      }

      .container-fluid h4 {
            display: none !important;
      }
}
</style>
<template>
      <div>
            <kendo-toolbar>
                  <b-navbar class="p-0">
                        <b-navbar-nav class="align-items-lg-center mr-auto">
                              <b-btn-toolbar key-nav>
                                    <b-btn-group class="mr-2" v-if="addOption">
                                          <core-GridToolbarButton text="Novo" icon="fas fa-plus"
                                                variant="outline-primary icon-btn" @click="editar()">
                                          </core-GridToolbarButton>
                                    </b-btn-group>
                                    <b-btn-group class="mr-2 buttons-edit" v-if="editOption || deleteOption">
                                          <!--botão editar-->
                                          <core-GridToolbarButton text="Editar" v-if="editOption"
                                                icon="fas fa-pencil-alt" variant="outline-secondary icon-btn"
                                                @click="editar(current)" :disabled="!current">
                                                <span class=""></span>
                                          </core-GridToolbarButton>
                                          <!--botão delete-->
                                          <core-GridToolbarButton class="mr-2" text="Excluir" v-if="deleteOption"
                                                icon="fas fa-trash" variant="outline-secondary icon-btn"
                                                @click="deletar" :disabled="!current">
                                          </core-GridToolbarButton>
                                    </b-btn-group>
                                    <b-btn-group class="mr-2" v-if="filterOption">
                                          <core-GridToolbarButton text="Filtrar" variant="outline-secondary icon-btn"
                                                icon="fas fa-filter" @click="filtrar">
                                          </core-GridToolbarButton>
                                    </b-btn-group>

                                    <!--botão exportar-->

                                    <b-btn-group v-if="exportOption">
                                          <core-GridToolbarButton text="Exportar" variant="outline-secondary icon-btn"
                                                icon="fas fa-file-excel" @click="exportar">
                                          </core-GridToolbarButton>
                                    </b-btn-group>

                                    <b-btn-group v-if="exportReportOption">
                                          <core-GridToolbarButton :disabled="dataList.length <= 0" text="Exportar"
                                                variant="outline-secondary icon-btn" icon="fas fa-file-excel"
                                                @click="openModalRelatorio()">
                                          </core-GridToolbarButton>
                                    </b-btn-group>

                                    <slot name="navbarButtons" v-if="rendered"></slot>
                              </b-btn-toolbar>
                        </b-navbar-nav>
                  </b-navbar>

                  <!-- slot para botões extras na toolbar do grid -->
                  <slot name="extraBtns" v-if="rendered"></slot>
                  <b-navbar class="p-0 custom-navbar-right">
                        <b-navbar-nav>
                              <b-nav-form v-on:submit.prevent>
                                    <b-input-group v-show="!searchDisabled">
                                          <b-input-group-text slot="append">
                                                <span class="fas fa-search" v-on:click="refresh"></span>
                                          </b-input-group-text>
                                          <b-input v-model="searchParams" placeholder="Filtrar" type="text" />
                                    </b-input-group>
                              </b-nav-form>
                        </b-navbar-nav>
                  </b-navbar>
            </kendo-toolbar>
            <kendo-grid v-if="showGrid" id="grid" ref="grid" :navigatable="true" :pageable="pageable"
                  :selectable="false" :resizable="true" :scrollable="true" :sortable="sortable"
                  :sortable-allow-unsort="true" :class="extratoMode ? 'extrato' : ''" width="100%" :auto-bind="autoBind"
                  v-on:databound="onDataBound" @change="onRowClick"
                  :row-template="rowSpan ? customRowTemplate : undefined">
                  <slot name="gridColumns"></slot>
            </kendo-grid>
            <RelatorioModal ref="relatorio_modal" :submit="submitRelatorio"
                  :TipoArquivoRelatorio="tipoArquivoRelatorioAceito" :scrollable="false"></RelatorioModal>
      </div>
</template>

<script>
import { saveExcel } from '@progress/kendo-vue-excel-export'
import RelatorioModal from './RelatorioModal'

export default {
      name: 'core-Grid',
      data() {
            return {
                  current: null,
                  searchParams: '',
                  filtroDiferences: 0,
                  dataList: [],
                  gridCheckBox: false,
                  showGrid: true,
                  autoBindDefault: false,
                  parentComponent: null,
                  rendered: false,
                  gridName: 'grid',
                  checkAllId: '',
            }
      },
      components: {
            RelatorioModal
      },
      watch: {
            searchParams: function (newValue, oldValue) {
                  if (newValue !== oldValue) this.debouncedRefresh()
            }
      },
      created() {
            this.debouncedRefresh = this._.debounce(this.refresh, 500)
      },
      beforeMount() {
            var grid = this.$parent.$children.find(p => p.$options.name === 'core-Grid')

            var cols = grid.$slots.gridColumns
            for (var i = 0; i < cols.length; i++) {
                  var item = cols[i]
                  this.setTemplate(item)
            }

            this.checkAllId = `check_all${this.generateRandomValue()}`
      },
      mounted() {
            this.gridName = this.$options._parentVnode.data.ref
            this.parentComponent = this.$parent
            while (this.parentComponent) {
                  if (this.parentComponent.$refs[this.gridName]) {
                        break
                  }
                  this.parentComponent = this.parentComponent.$parent
            }
            // Precisa reiniciar o componente para as alterações das Options fazerem efeito
            this.showGrid = false
            this.$nextTick(function () {
                  this.showGrid = true
                  this.$nextTick(function () {
                        // Método de inicialização
                        var vm = this
                        var grid = this.$refs.grid.kendoWidget()

                        if (
                              this.filterOpen &&
                              this.parentComponent.$refs[this.filterFunction]
                        ) {
                              this.filtrar()
                        }

                        var dataSource = this.getDataSource(grid)
                        grid.setOptions(this.getOptions(grid))
                        this.$nextTick(function () {
                              grid.setDataSource(dataSource)
                              vm.rendered = true
                              var gridElement = grid.element
                              var toolbarElement = gridElement.find('.k-grid-toolbar')
                              toolbarElement.on('click', '.k-pager-refresh', function (e) {
                                    e.preventDefault()
                                    vm.refresh()
                              })
                        })
                  })
            })
      },
      computed: {
            selecionados() {
                  return this.dataList.filter(p => p.selecionado)
            },
            countSelecionados: {
                  get() {
                        return this.selecionados.length
                  }
            }
      },
      methods: {
            read: function (options) {
                  if (
                        this.parentComponent.$refs[this.filterFunction] &&
                        this.parentComponent.$refs[this.filterFunction].countDiferences
                  ) {
                        this.filtroDiferences =
                              this.parentComponent.$refs[this.filterFunction].countDiferences
                  }
                  if (this.blockUI) {
                        this.$api.UI.ShowLoading()
                  }
                  this.onRead(options, this.searchParams)
            },
            customRowTemplate(dataItem) {
                  const columns = this.$refs.grid.kendoWidget().columns;
                  const dataItems = this.$refs.grid.kendoWidget().dataSource.data();
                  const currentIndex = dataItems.indexOf(dataItem);

                  return `<tr>${this.generateCells(dataItem, columns, currentIndex, dataItems)}</tr>`;
            },
            generateCells(dataItem, columns, currentIndex, allData) {
                  const cellsHtml = [];
                  const activeRowspans = this.getActiveRowspans(currentIndex, allData, columns);
                  const isAlternateRow = Math.floor(currentIndex / Object.values(this.rowSpanConfig)[0]) % 2 === 1;
                  const baseColor = 'rgb(0, 0, 0,.04)';

                  columns.forEach((column, columnIndex) => {
                        const field = column.field;
                        if (activeRowspans[field]) {
                              return;
                        }

                        const bgColor = isAlternateRow ? ` background-color: ${baseColor};` : 'background-color: rgb(255, 255, 255,.05);';

                        if (!this.shouldApplyRowSpan(field)) {
                              cellsHtml.push(
                                    `<td style="text-align: center; padding: 0.75rem; border: 1px solid #e5e7eb;${bgColor}">
                                    ${this.formatCellValue(dataItem[field])}
                                    </td>`
                              );
                              return;
                        }

                        const rowspanInfo = this.calculateRowSpanForField(
                              field,
                              currentIndex,
                              allData,
                              this.rowSpanConfig[field]
                        );

                        if (rowspanInfo.shouldRender) {
                              cellsHtml.push(
                                    `<td rowspan="${rowspanInfo.spanCount}" 
                                    style="text-align: center; padding: 0.75rem; border: 1px solid #e5e7eb;${bgColor}">
                                                ${this.formatCellValue(dataItem[field])}
                                    </td>`
                              );
                        }
                  });

                  return cellsHtml.join('');
            },
            getActiveRowspans(currentIndex, allData, columns) {
                  const activeRowspans = {};

                  if (currentIndex === 0) return activeRowspans;

                  columns.forEach(column => {
                        const field = column.field;
                        if (!this.shouldApplyRowSpan(field)) return;

                        for (let i = currentIndex - 1; i >= 0; i--) {
                              const prevRowspanInfo = this.calculateRowSpanForField(
                                    field,
                                    i,
                                    allData,
                                    this.rowSpanConfig[field]
                              );

                              if (prevRowspanInfo.shouldRender) {
                                    const spanRange = i + prevRowspanInfo.spanCount;
                                    if (currentIndex < spanRange && allData[i][field] === allData[currentIndex][field]) {
                                          activeRowspans[field] = true;
                                          break;
                                    }
                              }
                        }
                  });

                  return activeRowspans;
            },
            calculateRowSpanForField(field, currentIndex, data, maxSpan) {
                  if (currentIndex > 0 && data[currentIndex - 1][field] === data[currentIndex][field]) {
                        const prevRowActive = this.isPartOfPreviousRowSpan(field, currentIndex, data);
                        if (prevRowActive) {
                              return { shouldRender: false };
                        }
                  }

                  let spanCount = 1;
                  for (let i = currentIndex + 1; i < data.length && spanCount < maxSpan; i++) {
                        if (data[i][field] === data[currentIndex][field]) {
                              spanCount++;
                        } else {
                              break;
                        }
                  }

                  return {
                        shouldRender: true,
                        spanCount: spanCount
                  };
            },
            isPartOfPreviousRowSpan(field, currentIndex, data) {
                  for (let i = currentIndex - 1; i >= 0; i--) {
                        if (data[i][field] !== data[currentIndex][field]) {
                              return false;
                        }
                        const rowspanInfo = this.calculateRowSpanForField(
                              field,
                              i,
                              data,
                              this.rowSpanConfig[field]
                        );
                        if (rowspanInfo.shouldRender &&
                              i + rowspanInfo.spanCount > currentIndex) {
                              return true;
                        }
                  }
                  return false;
            },

            formatCellValue(value) {
                  if (value === null || value === undefined) {
                        return '';
                  }
                  return String(value).replace(/</g, '&lt;').replace(/>/g, '&gt;');
            },

            shouldApplyRowSpan(field) {
                  return this.rowSpanConfig && typeof this.rowSpanConfig[field] === 'number';
            },
            editar: function (current) {
                  if (current) {
                        this.parentComponent.$refs[this.editFunction].openModal({ ...current })
                  } else {
                        this.parentComponent.$refs[this.editFunction].openModal()
                  }
            },
            filtrar: function (current) {
                  this.parentComponent.$refs[this.filterFunction].openModal()
            },
            deletar: function () {
                  let th = this
                  if (this.current) {
                        this.$api.UI.Confirmacao(this.deleteConfirmMsg, function () {
                              th.parentComponent[th.deleteFunction](th.current)
                        })
                  }
            },
            exportar: function () {
                  if (this.serverPaging) this.parentComponent[this.exportFunction]()
                  else if (this.exportFunction === 'exportExcel') this.exportExcel()
                  else this.parentComponent[this.exportFunction]()
            },
            exportExcel(ds) {
                  let th = this
                  if (!ds) ds = th.$refs.grid.kendoWidget('dataSource').dataSource._data

                  if (ds.length) {
                        let columns = th.$refs.grid.kendoWidget('gridColumns').columns

                        var index = columns.findIndex(col => col.field === 'selecionado')

                        if (index >= 0) columns.splice(index, 1)

                        var exportName = this.exportFileName
                        if (!exportName) {
                              exportName = this.$route.meta.title
                        }

                        saveExcel({
                              data: ds,
                              fileName: exportName,
                              columns: columns
                        })
                  }
            },
            rowCount: function () {
                  return this.$refs.grid.kendoWidget().dataSource._data.length
            },
            getDataSource: function (grid) {
                  var th = this
                  if (th.serverPaging) {
                        return new kendo.data.DataSource({
                              transport: {
                                    read: th.read
                              },
                              serverPaging: true,
                              serverSorting: true,
                              batch: true,
                              pageSize: th.pageable ? th.pageSize : null,
                              schema: {
                                    data: 'data',
                                    total: 'total',
                                    errors: 'errors',
                                    model: {
                                          fields: th.getSchema(grid)
                                    }
                              }
                        })
                  } else {
                        return new kendo.data.DataSource({
                              transport: {
                                    read: th.read
                              },
                              batch: true,
                              pageSize: th.pageable ? th.pageSize : null,
                              schema: {
                                    model: {
                                          fields: th.getSchema(grid)
                                    }
                              }
                        })
                  }
            },
            onDataBound: function () {
                  this.$nextTick(function () {
                        if (this.$refs.grid) {
                              if (this.blockUI) {
                                    this.$api.UI.HideLoading()
                              }
                              var grid = this.$refs.grid.kendoWidget()
                              for (let i = 0; i < grid.columns.length; i++) {
                                    if (!grid.columns[i].width && !grid.columns[i].hidden) {
                                          grid.autoFitColumn(i)
                                    }
                              }
                              this.dataList = grid.dataSource.data()
                              if (this.gridCheckBox) {
                                    var viewList = grid.dataSource.view()
                                    if (this.$refs.grid.$el && viewList) {
                                          for (let i = 0; i < viewList.length; i++) {
                                                var item = viewList[i]
                                                var checkbox = this.$refs.grid.$el.querySelector(
                                                      "tr[data-uid='" + item.uid + "'] .custom-grid-checkbox input"
                                                )
                                                if (checkbox !== null) {
                                                      checkbox.checked = item.selecionado
                                                }
                                          }
                                    }
                              }
                        }
                  })
            },
            changeSelectAll: function (e) {
                  var grid = this.getGrid()
                  this.dataList.forEach(p => (p.selecionado = e))
                  grid.element[0]
                        .querySelectorAll(
                              `.custom-grid-checkbox.custom-control.custom-checkbox input:not(#${this.checkAllId})`
                        )
                        .forEach(p => (p.checked = e))
            },
            changeSelected: function (e, curr) {
                  var grid = this.getGrid()
                  var item = this.dataList.find(p => p.uid === curr.uid)

                  if (this.onChecked) {
                        this.onChecked(e, curr, item)
                  } else {
                        item.selecionado = e
                  }

                  if (
                        this.dataList.filter(p => p.selecionado === true).length ===
                        this.dataList.length
                  ) {
                        grid.element[0]
                              .querySelectorAll(
                                    `.custom-grid-checkbox.custom-control.custom-checkbox input#${this.checkAllId}`
                              )
                              .forEach(p => {
                                    p.checked = true
                                    p.indeterminate = false
                              })
                  } else if (this.dataList.filter(p => p.selecionado === true).length > 0) {
                        grid.element[0]
                              .querySelectorAll(
                                    `.custom-grid-checkbox.custom-control.custom-checkbox input#${this.checkAllId}`
                              )
                              .forEach(p => {
                                    p.checked = false
                                    p.indeterminate = true
                              })
                  } else {
                        grid.element[0]
                              .querySelectorAll(
                                    `.custom-grid-checkbox.custom-control.custom-checkbox input#${this.checkAllId}`
                              )
                              .forEach(p => {
                                    p.checked = false
                                    p.indeterminate = false
                              })
                  }

                  this.$emit('checkboxChange', item)
            },
            onRowClick: function (event) {
                  let grid = event.sender
                  this.current = grid.dataItem(grid.select())
            },
            setTemplate: function (item, props) {
                  if (item.componentOptions.propsData) {
                        props = item.componentOptions.propsData
                  }
                  var field = props.field
                  switch (props.template) {
                        case 'button':
                              if (item.data) {
                                    if (item.data.attrs && item.data.attrs.text) {
                                          props.width = 60 + item.data.attrs.text.length * 5
                                    }
                                    if (item.data.attrs && item.data.attrs.icon) {
                                          props.width = (props.width ? props.width : 0) + 10
                                    }
                              }
                              props.template = e => this.$api.UTIL.Functions.GridButtom(e, item)
                              break
                        case 'documento':
                              props.template = e => this.$api.UI.Template.DocumentoFederal(e, field)
                              break
                        case 'telefone':
                              // var field = props.field
                              props.template = e => this.$api.UI.Template.Telefone(e, field)
                              break
                        case 'contabil':
                              // var field = props.field
                              var operacao = item.data.attrs.operacao
                              props.template = e =>
                                    this.$api.UI.Template.ValorContabil(e, field, operacao)
                              props.format = 'decimal'
                              break
                        case 'checkbox':
                              this.gridCheckBox = true
                              item.data.attrs.change = this.changeSelected
                              props.field = 'selecionado'
                              props.sortable = false
                              var headerProps = {
                                    data: { attrs: { change: this.changeSelectAll, id: this.checkAllId } }
                              }
                              props.headerTemplate = e =>
                                    this.$api.UTIL.Functions.GridCheckbox(e, headerProps)
                              props.template = e => this.$api.UTIL.Functions.GridCheckbox(e, item)
                              break
                        default:
                              break
                  }
                  return item
            },
            getSchema: function (grid) {
                  if (this.schemaModelFields) {
                        return this.schemaModelFields
                  } else {
                        var fields = {}

                        if (grid.columns) {
                              for (var i = 0; i < grid.columns.length; i++) {
                                    var col = grid.columns[i]
                                    fields[col.field] = { editable: false, sortable: true }

                                    switch (col.format) {
                                          case 'date':
                                          case 'datetime':
                                                fields[col.field].type = 'date'
                                                break
                                          case 'currency':
                                          case 'decimal':
                                                fields[col.field].type = 'number'
                                                break
                                          default:
                                                break
                                    }

                                    if (col.attributes) {
                                          if (col.attributes['nullable']) {
                                                fields[col.field].nullable = col.attributes['nullable']
                                          }
                                          if (col.attributes['sortable']) {
                                                fields[col.field].nullable = col.attributes['sortable']
                                          }
                                    }
                              }
                        }
                        return fields
                  }
            },
            getOptions: function (grid) {
                  var options = grid.options
                  if (options.columns) {
                        for (var i = 0; i < options.columns.length; i++) {
                              var col = options.columns[i]
                              switch (col.format) {
                                    case 'date':
                                          options.columns[i].format = this.$api.UI.Format.Date
                                          break
                                    case 'datetime':
                                          options.columns[i].format = this.$api.UI.Format.DateTime
                                          break
                                    case 'currency':
                                          options.columns[i].format = this.$api.UI.Format.Currency
                                          options.columns[i].attributes = { style: 'text-align:right;' }
                                          break
                                    case 'decimal':
                                          options.columns[i].format = this.$api.UI.Format.Decimal
                                          options.columns[i].attributes = { style: 'text-align:right;' }
                                          break
                                    default:
                                          break
                              }
                        }
                  }
                  return options
            },
            refresh: function (e) {
                  this.current = null

                  if (
                        this.$refs.grid.pageable &&
                        this.$refs.grid.kendoWidget('dataSource').dataSource.page() > 1
                  ) {
                        this.$refs.grid.kendoWidget('dataSource').dataSource.page(1)
                  }
                  this.$refs.grid.kendoWidget('dataSource').dataSource.read()
            },
            getGrid: function () {
                  return this.$refs.grid.kendoWidget()
            },
            getColumn() {
                  return this.$refs.grid.kendoWidget('gridColumns').columns
            },
            getColumnvalues(column) {
                  let ds = this.$refs.grid.kendoWidget('dataSource').dataSource._data
                  if (ds.length) {
                        let columnArray = []
                        ds.forEach(el => {
                              let value = el[column]

                              if (value) {
                                    columnArray.push(value)
                              }
                        })

                        return columnArray
                  }
            },
            openModalRelatorio() {
                  this.$refs.relatorio_modal.openModal()
            },
            generateRandomValue() {
                  return Math.floor(100000 + Math.random() * 900000);
            }
      },
      props: {
            onRead: Function,
            pageSize: { type: Number, default: 10 },
            blockUI: { type: Boolean, default: true },
            pageable: { type: Boolean, default: true },
            autoBind: { type: Boolean, default: true },
            sortable: { type: Boolean, default: true },
            addOption: { type: Boolean, default: true },
            editOption: { type: Boolean, default: true },
            onChecked: { type: Function, default: null },
            filterOpen: { type: Boolean, default: false },
            extratoMode: { type: Boolean, default: false },
            deleteOption: { type: Boolean, default: true },
            serverPaging: { type: Boolean, default: false },
            exportOption: { type: Boolean, default: false },
            filterOption: { type: Boolean, default: false },
            editFunction: { type: String, default: 'editar' },
            searchDisabled: { type: Boolean, default: false },
            exportFileName: { type: String, default: null },
            schemaModelFields: { type: Object, default: null },
            exportFunction: { type: String, default: 'exportExcel' },
            submitRelatorio: { type: Function, default: null },
            exportReportOption: { type: Boolean, default: false },
            filterFunction: { type: String, default: 'filtrar' },
            deleteFunction: { type: String, default: 'excluir' },
            rowSpan: { type: Boolean, default: false },
            rowSpanConfig: {
                  type: Object,
                  default: () => ({}),
                  validator: (config) => {
                        return Object.values(config).every(value =>
                              typeof value === 'number' && value > 0
                        );
                  }
            },
            deleteConfirmMsg: {
                  type: String,
                  default: 'Confirma a exclusão do registro?'
            },
            tipoArquivoRelatorioAceito: Array
      },
      emits: ['checkboxChange']
}
</script>
